import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Hook to award trophy to student after completing quest
 * @returns {{
 *  awardStudentTrophy: (payload: { quest_id: number }) => Promise<any>,
 *  loading: boolean,
 *  error: string
 * }}
 */
export const useAwardStudentTrophy = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  const awardStudentTrophy = async (payload) => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/student/award/trophy`,
        payload
      );

      return response?.data;
    } catch (err) {
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { awardStudentTrophy, loading, error };
};
